import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CryptoJS from "crypto-js";
import { Box, HStack, Input, Pressable, Text, VStack, useMediaQuery } from "native-base";
import AccordionDetail from "../../components/accordion";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { COLORS } from "../../utils/colors";
import ToggleButton from "../../components/toggle";
import BasicDetailContents from "./modalChildren/basicDetails";
import PeopleDetailsListing from "../../pages/requestEventDetailPage/peopleDetailsListing";
import CommonAvatar from "../../components/avatar";
import { addIconSVG } from "../../utils/svg";
import Svg from "react-native-svg";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import CustomButton from "../../components/button";
import CustomModal from "../../components/modal";
import { AddNewPeople } from "../../pages/requestEventDetailPage/peopleDetailsListing/modalChildren";
import { TravelWallet } from "../../pages/quickLinkDetailsPage/modalChildren/walletListing/modalChildren";
import { Toaster } from "../../components/toaster";
import { uploadFileAPI } from "../../api/apis/workflow";
import EventWalletListing from "./modalChildren/eventWalletListing";
import {
  addBoardingPassAPI,
  checkValidAttendeesUpload,
  uploadExtraEventDocs,
} from "../../api/apis/event";
import { uploadWalletsAPI, listQuotationsAPI, deleteQuotationAPI } from "../../api/apis/quicklinks";
import { hasPermission, statusMap } from "../../utils/permission";
import MobileModelSheet from "../../components/actionSheet";
import DividerLine from "../../components/divider";
import { LoaderAnimation } from "../../components/spinner";
import FormHeader from "../../components/formHeader";
import AttachmentsCards from "../attachmentCards";
import DocumentUploader from "../documents";
import FileUploader from "../fileUpload";
import InputField from "../../components/input";
import config from "../../utils/config";

const EventDetails = ({
  scrollToTop = () => {},
  getEventDetails,
  workflow,
}) => {
  const history = useHistory();
  const childRef = useRef(null);
  const childref = useRef(null);
  const documentUploaderRef = useRef(null);
  const toaster = Toaster();
  const [isOpen, setIsOpen] = useState(false);
  const [tabActiveButton, setTabActiveButton] = useState("Details");
  const [uploadActiveButton, setUploadActiveButton] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState([]);
  const [selected, setSelected] = useState(false);
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    type: "",
    event: "",
    document_name: "",
    documents: "",
    id: "",
  });
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const eventsDetail = useSelector((state) => {
    return state.event.selectedEvent;
  });
  const [forceRemount, setForceRemount] = useState(false);
  const [uploadDoc, setUploadDoc] = useState({
    people: {},
    file_name: "",
    files: [],
  });
  const [attendeeSearchQuery, setAttendeeSearchQuery] = useState("");
  const [appliedAttendeeSearchQuery, setAppliedAttendeeSearchQuery] = useState("");
  const [quotations, setQuotations] = useState([]);
  const [loadingQuotations, setLoadingQuotations] = useState(false);
  const [quotationData, setQuotationData] = useState(null); // Store full quotation data object

  const options = () => {
    if (hasPermission("VENDOR")) return ["Details", "Attendees"];
    else if (hasPermission("LANDING_PAGE") && !hasPermission("RAISE_REQUEST"))
    {
      if (userInfo?.role === "External_employee") {
        return ["Details", "Wallet"];
      }
      return ["Details","Attendees","Wallet"];
    }
    else return ["Details", "Attendees", "Wallet"];
  };

  // Get user info
  const getUserInfo = () => {
    try {
      const bytes = CryptoJS.AES.decrypt(
        sessionStorage.getItem("content"),
        config.userKey
      );
      const jsonString = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(jsonString);
    } catch (e) {
      return null;
    }
  };

  // Get travel_partner_id from eventsDetail.agency based on user email
  const getTravelPartnerId = () => {
    const userInfo = getUserInfo();
    if (!eventsDetail?.agency || eventsDetail.agency.length === 0) {
      return null;
    }

    // If user is a vendor, try to find their agency by email match
    if (userInfo?.email) {
      const userAgency = eventsDetail.agency.find((agency) => {
        if (Array.isArray(agency.emailId)) {
          return agency.emailId.includes(userInfo.email);
        }
        return agency.emailId === userInfo.email;
      });
      if (userAgency?.id) {
        return userAgency.id;
      }
    }

    // If no match found and user is vendor, use first active agency
    // Otherwise, use first agency as fallback
    const activeAgency = eventsDetail.agency.find(agency => agency.status === 'active');
    if (activeAgency?.id) {
      return activeAgency.id;
    }
    
    // Final fallback: use first agency's id
    return eventsDetail.agency[0]?.id || null;
  };

  const getVendorAgency = () => {
    const userInfo = getUserInfo();
    if (!eventsDetail?.agency || eventsDetail.agency.length === 0) {
      return null;
    }

    if (userInfo?.email) {
      const userAgency = eventsDetail.agency.find((agency) => {
        if (Array.isArray(agency.emailId)) {
          return agency.emailId.includes(userInfo.email);
        }
        return agency.emailId === userInfo.email;
      });
      if (userAgency) {
        return userAgency;
      }
    }

    return (
      eventsDetail.agency.find((agency) => agency.status === "active") ||
      eventsDetail.agency[0] ||
      null
    );
  };

  const isEventCompleted = statusMap.indexOf(eventsDetail?.status) >= 3;
  const isAddInvoiceFlow =
    hasPermission("VENDOR") &&
    isEventCompleted &&
    getVendorAgency()?.status === "active";
    console.log(isAddInvoiceFlow,'check')
    console.log(userInfo.role)
    console.log(isEventCompleted)
    console.log(getVendorAgency()?.status)

  // Track if quotations have been fetched to prevent multiple calls
  const [quotationsFetched, setQuotationsFetched] = useState(false);

  // Check if user is admin or initiator
  const isAdminOrInitiator = () => {
    const userInfo = getUserInfo();
    return userInfo?.role === 'admin' || hasPermission('ADMIN') || userInfo?.role === 'initiator';
  };

  // Extract version from file name (e.g., "quotation_v7_..." -> "Quotation V7")
  const extractQuotationVersion = (fileName) => {
    if (!fileName) return 'Quotation';
    // Match pattern like "quotation_v7" or "quotation_v7_"
    const match = fileName.match(/quotation[_-]v(\d+)/i);
    if (match && match[1]) {
      return `Quotation V${match[1]}`;
    }
    return 'Quotation';
  };

  // Extract agency quotations from eventsDetail for admin/initiator
  const getAgencyQuotations = () => {
    if (!eventsDetail?.agency || !Array.isArray(eventsDetail.agency)) {
      return [];
    }
    return eventsDetail.agency
      .filter(agency => agency?.quotation_path && Object.keys(agency.quotation_path).length > 0)
      .map(agency => ({
        agency_name: agency.name,
        agency_id: agency.id,
        ...agency.quotation_path
      }));
  };

  // Extract agency invoices from eventsDetail for admin/vendor
  const getAgencyInvoices = () => {
    if (!eventsDetail?.agency || !Array.isArray(eventsDetail.agency)) {
      return [];
    }
    return eventsDetail.agency
      .filter(agency => agency?.invoice_path && Object.keys(agency.invoice_path).length > 0)
      .map(agency => ({
        agency_name: agency.name,
        agency_id: agency.id,
        ...agency.invoice_path
      }));
  };

  // Fetch quotations
  useEffect(() => {
    const fetchQuotations = async () => {
      if (!eventsDetail?._id || !hasPermission("QUOTATION") || eventsDetail?.self_agency_approval) {
        return;
      }

      // Skip API call for admin and initiator - they get data from eventsDetail.agency
      if (isAdminOrInitiator()) {
        const agencyQuotations = getAgencyQuotations();
        if (agencyQuotations.length > 0) {
          setQuotations(agencyQuotations);
          setQuotationData({ is_empty: false, quotation_reports: agencyQuotations });
        } else {
          setQuotations([]);
          setQuotationData(null);
        }
        return;
      }

      // For vendor: only fetch once
      if (quotationsFetched) {
        return;
      }

      setQuotationsFetched(true);
      setLoadingQuotations(true);
      try {
        const travel_partner_id = getTravelPartnerId();
        if (!travel_partner_id) {
          setQuotationsFetched(false);
          return;
        }
        const response = await listQuotationsAPI(eventsDetail._id, travel_partner_id);
        if (!response.error && response.data?.data?.data) {
          const quotationList = response.data.data.data;
          if (Array.isArray(quotationList) && quotationList.length > 0) {
            const quotationItem = quotationList[0];
            setQuotationData(quotationItem);
            if (!quotationItem.is_empty && quotationItem.quotation_reports && quotationItem.quotation_reports.length > 0) {
              setQuotations(quotationItem.quotation_reports);
            } else {
              setQuotations([]);
            }
          } else {
            setQuotationData(null);
            setQuotations([]);
          }
        }
      } catch (error) {
        console.error('Error fetching quotations:', error);
        setQuotationsFetched(false);
      } finally {
        setLoadingQuotations(false);
      }
    };
    fetchQuotations();
  }, [eventsDetail?._id, eventsDetail?.agency]);

  // Handle delete quotation - called directly from AttachmentsCards onDeleteFile
  const handleDeleteQuotation = async (quotation_id) => {
    if (!quotation_id) {
      toaster('Quotation ID is missing', 'error', 'error');
      return;
    }

    LoaderAnimation.show();

    try {
      const response = await deleteQuotationAPI(quotation_id);
      if (response.error) {
        toaster(response.message || 'Failed to delete quotation', 'error', 'error');
        return;
      }

      toaster('Quotation deleted successfully', 'success', 'success');
      
      // Refresh quotations list
      setQuotationsFetched(false);
      const travel_partner_id = getTravelPartnerId();
      const refreshResponse = await listQuotationsAPI(eventsDetail._id, travel_partner_id);
      if (!refreshResponse.error && refreshResponse.data?.data?.data) {
        const quotationList = refreshResponse.data.data.data;
        if (Array.isArray(quotationList) && quotationList.length > 0) {
          const quotationItem = quotationList[0];
          setQuotationData(quotationItem);
          if (!quotationItem.is_empty && quotationItem.quotation_reports && quotationItem.quotation_reports.length > 0) {
            setQuotations(quotationItem.quotation_reports);
          } else {
            setQuotations([]);
          }
        } else {
          setQuotationData(null);
          setQuotations([]);
        }
      }
      setQuotationsFetched(true);
    } catch (error) {
      console.error('Error deleting quotation:', error);
      toaster('Error deleting quotation', 'error', 'error');
    } finally {
      LoaderAnimation.hide();
    }
  };

  useEffect(() => {
    if (tabActiveButton === "Wallet" && eventsDetail) {
      setSelectedValue({
        ...selectedValue,
        type: eventsDetail.type,
        event: eventsDetail.event_name,
        id: eventsDetail._id,
      });
    }

    // Reset search when switching away from Attendees tab
    if (tabActiveButton !== "Attendees") {
      setAttendeeSearchQuery("");
      setAppliedAttendeeSearchQuery("");
    }

    eventsDetail &&
      eventsDetail.agency &&
      eventsDetail.agency.map((item) => {
        if (item.emailId && item.emailId.includes(userInfo.email)) {
          if (item.status === "active") {
            setSelected(true);
          }
        }
      });
  }, [tabActiveButton, eventsDetail]);

  const openModal = () => {
    scrollToTop();
    setForceRemount(!forceRemount);
    setSelectedFiles([]);
    setSelectedValue({ ...selectedValue, document_name: "", documents: "" });
    setShowModal(true);
  };

  const closeModal = () => {
    setForceRemount(!forceRemount);
    setSelectedValue({ ...selectedValue, document_name: "", documents: "" });
    setFile([]);
    setSelectedFiles([]);
    setUploadDoc({
      people: {},
      file_name: "",
      files: [],
    });
    setUploadActiveButton("");
    setShowModal(false);
  };

  const getStartDateFormat = (dateString) => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    }
    function formatDate(date) {
      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate()),
        ].join("-") +
        "T" +
        [
          padTo2Digits(date.getHours()),
          padTo2Digits(date.getMinutes()),
          padTo2Digits(date.getSeconds()),
        ].join(":") +
        "." +
        "616838+00:00"
      );
    }
    const formattedDate = formatDate(date);

    return formattedDate;
  };

  const uploadFilesToServer = async (data, type) => {
    let docs = [];
    let res = await uploadFileAPI(data, undefined, type);

    res.map((item) => {
      if (item.error) {
        toaster("Upload file failed", "error", "error");
        return;
      }
      if (item.data.data.data) {
        docs.push({
          doc_type: item.data.data.data.doc_type,
          file_size: item.data.data.data.file_size.toString(),
          file_name: item.data.data.data.file_name,
          uploaded_time: getStartDateFormat(new Date()),
        });
      }
    });
    return docs;
  };

  const handleFilesSelect = (files) => {
    setSelectedFiles(files);
    setUploadDoc({ ...uploadDoc, files: files });
  };

  const handleUploadDoc = (item, eName) => {
    if (eName === "file_name") {
      setUploadDoc({ ...uploadDoc, file_name: item.target.value });
    } else if (eName === "people") {
      setUploadDoc({ ...uploadDoc, people: item });
    }
  };

  // Clear icon SVG for attendee search
  const clearIconSVG = (
    <path
      d='M18 6L6 18M6 6L18 18'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  );

  // Handle clear attendee search
  const handleClearAttendeeSearch = () => {
    LoaderAnimation.show();
    setAttendeeSearchQuery("");
    setAppliedAttendeeSearchQuery("");
    
    // Hide loader after state updates and re-render completes
    setTimeout(() => {
      LoaderAnimation.hide();
    }, 100);
  };

  // Handle key press for attendee search
  const handleAttendeeSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      LoaderAnimation.show();
      // Apply the search query when Enter is pressed
      setAppliedAttendeeSearchQuery(attendeeSearchQuery);
      
      // Hide loader after state updates and re-render completes
      setTimeout(() => {
        LoaderAnimation.hide();
      }, 100);
    }
  };

  const getFilteredAttendees = () => {
    if (!eventsDetail?.employee) return [];
    
    if (!appliedAttendeeSearchQuery.trim()) {
      return eventsDetail.employee;
    }
    
    const searchLower = appliedAttendeeSearchQuery.toLowerCase().trim();
    return eventsDetail.employee.filter((attendee) => {
      const firstName = (attendee?.first_name || "").toLowerCase();
      const lastName = (attendee?.last_name || "").toLowerCase();
      const displayName = (attendee?.display_name || "").toLowerCase();
      const email = (attendee?.email || "").toLowerCase();
      
      return (
        firstName?.includes(searchLower) ||
        lastName?.includes(searchLower) ||
        displayName?.includes(searchLower) ||
        email?.includes(searchLower)
      );
    });
  };

  const getModalChildren = () => {
    if (tabActiveButton === "Details")
      return <BasicDetailContents getEventDetails={getEventDetails} />;
    else if (tabActiveButton === "Attendees")
      return (
        <PeopleDetailsListing
          selected={selected}
          eventsDetail={eventsDetail}
          setUploadActiveButton={setUploadActiveButton}
          openModal={openModal}
          handleUploadDoc={handleUploadDoc}
          getEventDetails={getEventDetails}
          filteredAttendees={getFilteredAttendees()}
        />
      );
    else if (tabActiveButton === "Wallet")
      return <EventWalletListing ref={childRef} />;
  };

  const getPopupModalTitle = () => {
    if (
      tabActiveButton === "Attendees" &&
      uploadActiveButton !== "upload_docs" &&
      showModal
    )
      return <Text>Add Attendees</Text>;
    else if (tabActiveButton === "Wallet")
      return <Text>Add Travel Wallet</Text>;
    else if (uploadActiveButton === "upload_docs")
      return <Text>Upload Documents</Text>;
  };

  const getPopupModalChildren = () => {
    if (
      tabActiveButton === "Attendees" &&
      uploadActiveButton !== "upload_docs" &&
      showModal
    )
      return (
        <AddNewPeople
          file={file}
          setFile={setFile}
          forceRemount={forceRemount}
          eventsDetail={eventsDetail}
        />
      );
    else if (tabActiveButton === "Wallet")
      return (
        <TravelWallet
          ref={childref}
          selectedTravelValue={selectedValue}
          setSelectedValue={setSelectedValue}
          isEvent={eventsDetail.type === "event" ? true : false}
          eventDetails={true}
          forceRemount={forceRemount}
          showModal={showModal}
        />
      );
    else if (uploadActiveButton === "upload_docs")
      return (
        <>
          <InputField
            name="file_name"
            value={""}
            label="File Name"
            placeholder="Enter File Name"
            // onChange={onInputChange}
            onChange={handleUploadDoc}
            forceRemount={forceRemount}
            ref={childref}
            width={!MobileWindow && "50%"}
          />
          {MobileWindow && <Box mb={3}></Box>}
          <FileUploader
            files={selectedFiles}
            show={true}
            setFiles={handleFilesSelect}
            accept={["png", "jpg", "jpeg", "pdf"]}
            types={".png, .jpg, .jpeg, .pdf"}
            forceRemount={forceRemount}
            // images={true}
          />
        </>
      );
  };

  const modalFooter = (
    <HStack width={MobileWindow && "100%"}>
      {/* <Box width={MobileWindow && "50%"} alignItems={MobileWindow && "center"}>
        <Text
          onPress={closeModal}
          color={COLORS.MODAL_BACK_BUTTON_COLOR}
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
          mt={3}
          mr={12}
        >
          Back
        </Text>
      </Box> */}
      <Box width={MobileWindow && "100%"}>
        <CustomButton
          onPress={async () => {
            LoaderAnimation.show();
            if (
              tabActiveButton === "Attendees" &&
              uploadActiveButton !== "upload_docs" &&
              showModal
            ) {
              if (file.length === 0) {
                toaster("Please add file to upload", "error", "error");
                LoaderAnimation.hide();
                return;
              }
              let payload = {
                employee_file_path: [],
                documents: [],
              };
              if (file?.[0].lastModified) {
                let postData = new FormData();
                postData.append("file", file?.[0]);
                let res = await checkValidAttendeesUpload(postData);
                if (res.error) {
                  toaster(res.message, "error", "error");
                  LoaderAnimation.hide();
                  return;
                } else {
                  let docs = await uploadFilesToServer(file, "people");
                  docs &&
                    docs.map((item) => {
                      payload.employee_file_path.push(item);
                    });

                  let res = await uploadExtraEventDocs(
                    eventsDetail._id,
                    payload
                  );
                  if (res.error) {
                    toaster(res.message, "error", "error");
                    LoaderAnimation.hide();
                    return;
                  } else {
                    toaster("Uploaded Successfully", "success", "success");
                    getEventDetails();
                    closeModal();
                  }
                }
              }
            } else if (uploadActiveButton === "upload_docs") {
              if (uploadDoc.file_name.length === 0) {
                toaster("Please add file name", "error", "error");
                LoaderAnimation.hide();
                return;
              }

              if (uploadDoc.files.length === 0) {
                toaster("Please add file to upload", "error", "error");
                LoaderAnimation.hide();
                return;
              }

              let payload = { ...eventsDetail };
              let docs = await uploadFilesToServer(uploadDoc.files, "wallet");
              let employee = payload["employee"].map((item) => {
                if (item.email === uploadDoc.people.email) {
                  if (item.boarding_pass_path) {
                    if (Array.isArray(docs[0])) {
                      return {
                        ...item,
                        boarding_pass_path: [
                          ...item.boarding_pass_path,
                          ...docs[0],
                        ],
                      };
                    } else {
                      docs[0]["doc_type"] = uploadDoc.file_name;
                      return {
                        ...item,
                        boarding_pass_path: [
                          ...item.boarding_pass_path,
                          docs[0],
                        ],
                      };
                    }
                  } else {
                    if (Array.isArray(docs[0])) {
                      return { ...item, boarding_pass_path: docs[0] };
                    } else {
                      docs[0]["doc_type"] = uploadDoc.file_name;
                      return { ...item, boarding_pass_path: [docs[0]] };
                    }
                  }
                } else {
                  return item;
                }
              });

              payload["employee"] = employee;
              payload["boarding_pass"] = employee.filter(
                (item) => item.email === uploadDoc.people.email
              );
              payload["boarding_pass"] = payload["boarding_pass"][0];
              payload["workflow_instance_id"] = payload["_id"];
              delete payload["_id"];

              let result = {
                instance: [payload],
              };

              let res = await addBoardingPassAPI(
                payload["workflow_id"],
                payload.current_step,
                result
              );

              if (res.error) {
                toaster(res.message, "error", "error");
                LoaderAnimation.hide();
                return;
              } else {
                toaster("Uploaded Successfully", "success", "success");
                getEventDetails();
                closeModal();
              }
            } else {
              let value = childref.current.onSubmitDataInput();
              setSelectedValue(value);
              if (
                value.document_name !== "" &&
                (value.document_name.length < 3 ||
                  !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
                    value.document_name
                  ))
              ) {
                toaster("Please enter proper Document Name", "error", "error");
              } else if (value.document_name.length > 500) {
                toaster(
                  "Please enter Document Name less than 500 characters",
                  "error",
                  "error"
                );
              } else if (
                value.type &&
                (value.type === "event" || value.type === "mice"
                  ? value.event
                  : !value.event) &&
                value.document_name
              ) {
                if (value.documents.length > 0) {
                  let docs = await uploadFilesToServer(
                    value.documents,
                    "wallet"
                  );
                  let payload = {
                    type: value.type,
                    event_id: value.id,
                    document_name: value.document_name,
                    added_by: userInfo.email,
                    file_name: docs[0].file_name,
                    documents: docs,
                  };
                  let res = await uploadWalletsAPI(payload);
                  if (res.error) {
                    toaster(res.message, "error", "error");
                    LoaderAnimation.hide();
                    return;
                  } else {
                    toaster("Uploaded Successfully", "success", "success");
                    childRef.current.getWalletListing();
                    closeModal();
                  }
                } else toaster("Upload a document", "error", "error");
              } else toaster("Enter all details", "error", "error");
            }
            LoaderAnimation.hide();
          }}
          text="Upload"
          color={COLORS.WHITE_COLOR}
        />
      </Box>
    </HStack>
  );

  const contents = () => {
    return (
      <VStack space={MobileWindow ? 4 : 6} w={"100%"}>
        <HStack justifyContent={"space-between"} alignItems={"center"}>
          <div>
            <ToggleButton
              options={options()}
              activeButton={tabActiveButton}
              setActiveButton={setTabActiveButton}
            />
          </div>
          
          <HStack space={4} alignItems={"center"}>
            {tabActiveButton === "Attendees" && (
              <Box position='relative'>
                <Input
                  placeholder="Search"
                  value={attendeeSearchQuery}
                  onChangeText={(text) => {
                    // Only remove leading spaces, preserve trailing and middle spaces
                    const trimmedText = text?.trimStart();
                    setAttendeeSearchQuery(trimmedText);
                    // If user clears the input with backspace, clear the applied search with loader
                    if (!trimmedText) {
                      LoaderAnimation.show();
                      setAppliedAttendeeSearchQuery("");
                      
                      // Hide loader after state updates and re-render completes
                      setTimeout(() => {
                        LoaderAnimation.hide();
                      }, 100);
                    }
                  }}
                  onKeyPress={handleAttendeeSearchKeyPress}
                  width={MobileWindow ? "200px" : "300px"}
                  height={MobileWindow ? "35px" : "45px"}
                  bg={COLORS.WHITE_COLOR}
                  borderColor={COLORS.BORDER_COLOR}
                  _focus={{ borderColor: COLORS.TABS_ACTIVE_BORDER_COLOR }}
                  fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                  paddingRight={attendeeSearchQuery ? '40px' : '12px'}
                />
                {attendeeSearchQuery && (
                  <Pressable
                    position='absolute'
                    right={2}
                    top={0}
                    bottom={0}
                    justifyContent='center'
                    alignItems='center'
                    onPress={handleClearAttendeeSearch}
                    p={1}
                    borderRadius={4}
                    _pressed={{ bg: COLORS.BORDER_COLOR }}
                  >
                    <Svg
                      width='16'
                      height='16'
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      {clearIconSVG}
                    </Svg>
                  </Pressable>
                )}
              </Box>
            )}
            
            {tabActiveButton !== "Details" &&
              ((tabActiveButton === "Attendees" &&
                (hasPermission("UPLOAD_DOCUMENTS") ||
                  (hasPermission("VENDOR") && selected))) ||
                tabActiveButton === "Wallet") && (
                <div>
                  <CommonAvatar
                    width={MobileWindow ? "35px" : "50px"}
                    height={MobileWindow ? "35px" : "50px"}
                    bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
                    svg={addIconSVG}
                    svgwh="24"
                    view="0 0 24 24"
                    onPress={openModal}
                    touchable={true}
                  />
                </div>
              )}
          </HStack>
        </HStack>
        {MobileWindow && <DividerLine direction="horizontal" />}
        {getModalChildren()}
      </VStack>
    );
  };

  return (
    <>
      <AccordionDetail
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Details"
        content={contents()}
      />
      {hasPermission("QUOTATION") && !eventsDetail?.self_agency_approval && (() => {
        // Check if user is admin or initiator
        const isAdmin = userInfo?.role === 'admin' || hasPermission('ADMIN');
        const isInitiator = userInfo?.role === 'initiator';
        const isAdminOrInitiatorUser = isAdmin || isInitiator;
        const isVendor = hasPermission('VENDOR');
        const vendorAgency = getVendorAgency();
        const isInactiveCompletedVendor =
          isVendor && isEventCompleted && vendorAgency?.status === "inactive";
        const hasVendorInvoicePath =
          !!vendorAgency?.invoice_path &&
          Object.keys(vendorAgency.invoice_path || {}).length > 0;
        
        // For admin/initiator: Get quotations from eventsDetail.agency
        const agencyQuotations = isAdminOrInitiatorUser ? getAgencyQuotations() : [];
        const hasAgencyQuotations = agencyQuotations.length > 0;
        
        // For vendor: Check if quotation data exists from API
        const hasQuotationData = !isAdminOrInitiatorUser && quotationData && !quotationData.is_empty && quotationData.quotation_reports && quotationData.quotation_reports.length > 0;

        // Hide section if no quotation data for admin/initiator
        if (isAdminOrInitiatorUser && !hasAgencyQuotations) {
          return null;
        }
        
        // For vendor: Always show section (they need to see plus icon when no quotation)
        // Don't hide section for vendors - they should see it even when empty

        // For inactive completed vendor with no quotation: hide section
        if (isInactiveCompletedVendor && !hasQuotationData) {
          return null;
        }

        // For initiator and other non-vendor, non-admin roles: Hide section if is_empty is true
        if (!isAdmin && !isVendor && !isInitiator && quotationData?.is_empty) {
          return null;
        }

        return (
          <>
            <VStack mt={"10"} space={4}>
              <HStack justifyContent="space-between" alignItems="center">
                <HStack alignItems="center" space={3}>
                  <Text
                    fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                    fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                    color={COLORS.ACCORDION_TITLE_COLOR}
                  >
                    Quotation
                  </Text>
                  {hasQuotationData && isVendor ? (
                    <CustomButton
                      onPress={() => {
                        scrollToTop();
                        history.push("/event-detail/quotations");
                      }}
                      text={
                        isAddInvoiceFlow
                          ? (hasVendorInvoicePath ? "View Invoice" : "Add Invoice")
                          : "View Quotation"
                      }
                      fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                      bgcolor={COLORS.UPLOAD_BUTTON_COLOR}
                      textColor={COLORS.WHITE_COLOR}
                      fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                      borderRadius="50px"
                    />
                  ) : !hasQuotationData && isVendor ? (
                    // Show plus icon for vendor when is_empty is true, or when no quotation data
                    <CommonAvatar
                      width={MobileWindow ? '35px' : '50px'}
                      height={MobileWindow ? '35px' : '50px'}
                      bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
                      svg={addIconSVG}
                      svgwh='24'
                      view='0 0 24 24'
                      onPress={() => {
                        scrollToTop();
                        history.push("/event-detail/quotations");
                      }}
                      touchable={true}
                    />
                  ) : null}
                </HStack>
                {!hasPermission("VENDOR") && eventsDetail?.agency?.some(agency => 
                  agency?.quotation_path && 
                  Object.keys(agency?.quotation_path)?.length > 0
                ) && (
                  <CustomButton
                    onPress={() => {
                      if (documentUploaderRef.current && documentUploaderRef.current.openCostBenchmarking) {
                        documentUploaderRef.current.openCostBenchmarking();
                      }
                    }}
                    text="ABG Event Bench"
                    color={COLORS.WHITE_COLOR}
                    bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
                  />
                )}
              </HStack>
              {/* Quotation Card View - Below View Quotation button */}
              {(hasQuotationData || hasAgencyQuotations) && (
                <Box>
                  <div
                    style={{
                      display: MobileWindow ? "flex" : "grid",
                      gridTemplateColumns: `repeat(auto-fill, minmax(${80 / 3}%, 1fr))`,
                      gap: "20px",
                      marginRight: !MobileWindow && "20px",
                      flexWrap: "wrap",
                    }}
                  >
                    {isAdminOrInitiatorUser ? (
                      // Display agency quotations for admin/initiator
                      agencyQuotations.map((agencyQuote, index) => {
                        const quotationVersion = extractQuotationVersion(agencyQuote?.file_name);
                        return (
                          <AttachmentsCards
                            key={agencyQuote?.agency_id || agencyQuote?.file_name || index}
                            fileName={`${quotationVersion} (${agencyQuote?.agency_name || 'Agency'})`}
                            timeline={agencyQuote?.uploaded_time}
                            fileSize=""
                            path={agencyQuote?.file_name ? config.bucketPath + agencyQuote.file_name : ''}
                            scrollToTop={scrollToTop}
                            height="fit-content"
                            quotation={true}
                            onDownloadFile={() => {
                              toaster('Quotation downloaded successfully', 'success', 'success');
                            }}
                            id={agencyQuote?.agency_id || ''}
                          />
                        );
                      })
                    ) : (
                      // Display vendor quotations from API
                      quotationData?.quotation_reports?.map((report, index) => (
                        <AttachmentsCards
                          key={report?.media_id || report?.version || index}
                          fileName={`Quotation ${report?.version_label || ''}`}
                          timeline={report?.generated_at}
                          fileSize=""
                          path={report?.file_name ? config.bucketPath + report.file_name : ''}
                          scrollToTop={scrollToTop}
                          height="fit-content"
                          // deleteIcon={!isAdmin}
                          quotation={true}
                          onDeleteFile={(path) => {
                            // When AttachmentsCards confirms delete, directly call delete API
                            // Use the main quotation_id from quotationData, not the nested quotation's _id
                            const quotation_id = quotationData?.quotation_id;
                            if (quotation_id) {
                              handleDeleteQuotation(quotation_id);
                            }
                          }}
                          onDownloadFile={() => {
                            toaster('Quotation downloaded successfully', 'success', 'success');
                          }}
                          id={report?.media_id || ''}
                        />
                      ))
                    )}
                  </div>
                </Box>
              )}
            </VStack>
            <HStack display="none">
              <DocumentUploader
                ref={documentUploaderRef}
                workflow={workflow}
                eventsDetail={eventsDetail}
                getEventDetails={getEventDetails}
              />
            </HStack>
          </>
        );
      })()}

      {(() => {
        if (!hasPermission("INVOICE")) {
          return null;
        }

        const isAdmin = userInfo?.role === "admin" || hasPermission("ADMIN");
        const isVendor = hasPermission("VENDOR");
        const vendorAgency = getVendorAgency();
        const isApprovedVendor = isVendor && vendorAgency?.status === "active";

        if (!isAdmin && !isApprovedVendor) {
          return null;
        }

        const agencyInvoices = isApprovedVendor && !isAdmin
          ? (vendorAgency?.invoice_path
            ? [{
              agency_name: vendorAgency?.name,
              agency_id: vendorAgency?.id,
              ...vendorAgency.invoice_path
            }]
            : [])
          : getAgencyInvoices();
        if (agencyInvoices.length === 0) {
          return null;
        }

        return (
          <VStack mt={"4"} space={4}>
            <HStack justifyContent="space-between" alignItems="center">
              <HStack alignItems="center" space={3}>
                <Text
                  fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                  fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                  color={COLORS.ACCORDION_TITLE_COLOR}
                >
                  Invoice
                </Text>
              </HStack>
            </HStack>
            <Box>
              <div
                style={{
                  display: MobileWindow ? "flex" : "grid",
                  gridTemplateColumns: `repeat(auto-fill, minmax(${80 / 3}%, 1fr))`,
                  gap: "20px",
                  marginRight: !MobileWindow && "20px",
                  flexWrap: "wrap",
                }}
              >
                {agencyInvoices.map((agencyInvoice, index) => (
                  <AttachmentsCards
                    key={agencyInvoice?.agency_id || agencyInvoice?.file_name || index}
                    fileName="Invoice"
                    timeline={agencyInvoice?.uploaded_time}
                    fileSize=""
                    path={agencyInvoice?.file_name ? config.bucketPath + agencyInvoice.file_name : ""}
                    scrollToTop={scrollToTop}
                    height="fit-content"
                    quotation={true}
                    onDownloadFile={() => {
                      toaster("Invoice downloaded successfully", "success", "success");
                    }}
                    id={agencyInvoice?.agency_id || ""}
                  />
                ))}
              </div>
            </Box>
          </VStack>
        );
      })()}

      {!MobileWindow ? (
        <CustomModal
          isOpen={showModal}
          onClose={closeModal}
          header={getPopupModalTitle()}
          body={getPopupModalChildren()}
          footer={modalFooter}
          width={"70%"}
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={getPopupModalTitle()}
          body={getPopupModalChildren()}
          footer={modalFooter}
        />
      )}
    </>
  );
};

export default EventDetails;
